import { VisualStepForm } from '../../../schemas/visualStepSchema';
import {
  CreateOrUpdateProgramPayload,
  ProgramAdditionalInformation,
} from '../../../types/program';

export const getVisualProgramPayload = (
  fields: VisualStepForm
): Partial<CreateOrUpdateProgramPayload> => {
  const additionalInformation: ProgramAdditionalInformation[] = [
    {
      name: fields.howItWorks?.name || 'Como funciona',
      description: fields.howItWorks?.description || '',
      activated: fields.howItWorks?.activated,
      order: 1,
      type: 'tab',
    },
    {
      name: fields.whoHelpYou?.name || 'Quem vai te ajudar',
      description: fields.whoHelpYou?.description || '',
      activated: fields.whoHelpYou?.activated || false,
      order: 2,
      type: 'tab',
    },
  ];

  return {
    teaser: fields.teaser || undefined,
    additionalInformation,
  };
};
